<template>
  <div class="wrapper">
    <span class="w-title">事务所管理</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <v-layout wrap>
        <v-flex xs12 sm6 md3>
          <v-text-field
            v-model="filters.q"
            label="事务所名称"
            outline
            solo
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3 style="display: flex;margin-bottom: 20px;">
          <v-btn color="info" style="margin-right: 5px !important;" @click="refresh">查询</v-btn>
          <v-btn color="info" @click="clearFilters">重置</v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-btn color="info" style="margin-right: 5px !important;" @click="addButtonClicked">新建</v-btn>
    <v-btn color="error" style="margin-right: 5px !important;" :disabled="canDelete" @click="deleteButtonClicked">删除</v-btn>
    <v-btn color="success" :disabled="canExport" outline style="margin-right: 5px !important;" @click="exportButtonClicked">导出</v-btn>

    <DataTable
      ref="dataTable"
      item-key="firmId"
      sort-by="name"
      :headers="headers"
      :fetch-data="refreshList"
      @editButtonClicked="editButtonClicked"
      @detailButtonClicked="detailButtonClicked"
    ></DataTable>
  </div>
</template>

<script>
  import axios from "../axios";
  import DataTable from "../components/DataTable2";
  import {mapActions} from 'vuex';
  import {dateFormat} from "vue-filter-date-format";

  export default {
    mounted() {
      this.isMounted = true;
    },
    components: {
      DataTable
    },
    computed:{
      canDelete() {
        if (this.isMounted) {
          return this.$refs.dataTable.selected.length === 0;
        } else {
          return false;
        }
      },
      canExport() {
        if (this.isMounted) {
          return this.$refs.dataTable.data.length === 0;
        } else {
          return false;
        }
      },
    },
    data: () => ({
      headers: [
        {
          text: "事务所名称",
          align: "left",
          value: "name"
        },
        {
          text: "创建时间",
          value: "createDate",
          formatter: v => dateFormat(new Date(v), "YYYY-MM-DD")
        },
        {
          text: "有效开始时间",
          value: "effectiveStart",
          //formatter: v => dateFormat(new Date(v), "YYYY-MM-DD")
        },
        {
          text: "有效结束时间",
          value: "effectiveEnd",
          //formatter: v => dateFormat(new Date(v), "YYYY-MM-DD")
        },
        {text: "操作", align: "center", value: "settings", sortable: false}
      ],
      isMounted: false,
      filters: {},
      ts: '',
      params: null,
    }),
    methods:{
      ...mapActions(["setLoading"]),
      refreshList(pagination, searchText, callback, failure) {
        this.params = {
          params: {
            page: pagination.page - 1,
            size: pagination.rowsPerPage === -1 ? 2147483647 : pagination.rowsPerPage,
            sort:
              pagination.sortBy === null
                ? null
                : pagination.sortBy +
                "," +
                (pagination.descending ? "desc" : "asc"),
            ...this.filters
          }
        };

        axios
          .get("/firms", this.params)
          .then(response => {
            callback(response.data.total, response.data.data);
          })
          .catch(reason => {
            if (failure) {
              failure(reason);
            }
          });
      },
      exportButtonClicked() {
        this.setLoading(true);
        axios
          .get("/firms/export", { ...this.params, responseType: "arraybuffer" })
          .then(response => {
            this.saveAs(new Blob([response.data]), "事务所.csv");
            this.setLoading(false);
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {buttonFalseText: null});
            this.setLoading(false);
          });
      },
      addButtonClicked() {
        this.$router.push({
          name: "firm-form-add"
        });
      },
      editButtonClicked(item) {
        this.$router.push({
          name: "firm-form-edit",
          params: {firmId: item.firmId}
        });
      },
      detailButtonClicked(item) {
        this.$router.push({
          name: "firm-form-detail",
          params: {firmId: item.firmId}
        });
      },
      deleteButtonClicked() {
        let items = this.$refs.dataTable.selected;
        this.$confirm("正在删除" + items.length + "个事务所，请确认").then(res => {
          if (res) {
            this.setLoading(true);
            axios
              .post("/firms/delete", {
                firmIds: items.map(item => item.firmId)
              })
              .then(() => {
                this.setLoading(false);

                this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                    this.refresh();
                  }
                );
              })
              .catch(reason => {
                this.$confirm(reason.response.data.message, {
                  buttonFalseText: null
                });
                this.setLoading(false);
              });
          }
        });
      },
      refresh() {
        this.$refs.dataTable.refresh();
      },
      clearFilters() {
        this.filters = {};
        this.refresh();
      }
    }
  }
</script>

